import { BmarkFixingEventOperation } from "./enums/BmarkFixingEventOperation.enum";
import { BmarkFixingData } from "./BmarkFixingData.model";

export class BmarkFixingEvent {
  public operation: BmarkFixingEventOperation;
  public payload: Array<BmarkFixingData> | BmarkFixingData | string | null;
  constructor(operation: BmarkFixingEventOperation, payload: any) {
    this.generate(operation, payload);
  }

  public generate(operation: BmarkFixingEventOperation, payload: any): void {
    this.operation = operation;
    this.payload = payload;
  }
}
